class ImgSrcGenerator {
    private readonly imgUrlTemplate: string;
    private readonly fallbackImgUrlTemplate: string;
    private readonly shopNumberPlaceholder: string;
    private readonly slideNumberPlaceholder: string;
    private readonly shopNumberFormat: string;

    constructor(
        imgUrlTemplate: string,
        fallbackImgUrlTemplate: string,
        shopNumberPlaceholder: string,
        slideNumberPlaceholder: string,
        shopNumberFormat: string
    ) {
        this.imgUrlTemplate = imgUrlTemplate;
        this.fallbackImgUrlTemplate = fallbackImgUrlTemplate;
        this.shopNumberPlaceholder = shopNumberPlaceholder;
        this.slideNumberPlaceholder = slideNumberPlaceholder;
        this.shopNumberFormat = shopNumberFormat;
    }

    public generateImgSrc(shopId: number, currentSlideIndex: number): string {
        return this.imgUrlTemplate
            .replace(
                this.shopNumberPlaceholder,
                this.convertNumberToStringWithLeadingZeros(shopId)
            )
            .replace(this.slideNumberPlaceholder, currentSlideIndex.toString());
    }

    public generateFallbackImgSrc(currentSlideIndex: number): string {
        return this.fallbackImgUrlTemplate.replace(
            this.slideNumberPlaceholder,
            currentSlideIndex.toString()
        );
    }

    private convertNumberToStringWithLeadingZeros(num: number): string {
        const format = this.shopNumberFormat;
        const numAsString = num.toString();

        return format.substring(numAsString.length) + numAsString;
    }
}

export default ImgSrcGenerator;
